import React from "react";
import type { MatchFacet } from "./api";

const STATUS_CLASS: Record<MatchFacet["status"], string> = {
  match: "bg-green-50 text-green-800",
  differs: "bg-red-50 text-red-800",
  note: "bg-amber-50 text-amber-800",
  unknown: "bg-gray-50 text-gray-500",
};

const STATUS_MARK: Record<MatchFacet["status"], string> = {
  match: "✓",
  differs: "✗",
  note: "~",
  unknown: "?",
};

const STATUS_TITLE: Record<MatchFacet["status"], string> = {
  match: "Matches the request",
  differs: "Does not match the request",
  note: "Different but acceptable (cut to length, same flat stock, optional condition)",
  unknown: "The item does not state this",
};

/**
 * Requested vs item, one row per attribute, coloured by verdict. Reads at a
 * glance where a close match falls short instead of a sentence of differences.
 */
export const FitTable = ({ facets, className = "" }: { facets: MatchFacet[]; className?: string }) => {
  if (!facets.length) return null;
  return (
    <table className={`mt-1 border-collapse text-[0.7rem] leading-tight ${className}`}>
      <thead>
        <tr className="text-left text-gray-500">
          <th className="pr-3 font-medium"></th>
          <th className="pr-3 font-medium">Requested</th>
          <th className="pr-3 font-medium">Item</th>
        </tr>
      </thead>
      <tbody>
        {facets.map((f) => (
          <tr key={f.key} className={STATUS_CLASS[f.status]} title={STATUS_TITLE[f.status]}>
            <td className="whitespace-nowrap py-0.5 pl-1 pr-3 font-medium">
              <span className="mr-1 inline-block w-3 text-center">{STATUS_MARK[f.status]}</span>
              {f.label}
            </td>
            <td className="py-0.5 pr-3">{f.requested || "—"}</td>
            <td className="py-0.5 pr-2">{f.item || "not stated"}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
